var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5217 0H2.92969C1.31426 0 0 1.31426 0 2.92969V22.0703C0 23.6857 1.31426 25 2.92969 25H22.0703C23.6857 25 25 23.6857 25 22.0703V4.47832L20.5217 0ZM7.66602 1.95312H13.4766V5.66406H15.4297V1.95312H17.3828V6.64062C17.3828 7.1791 16.9447 7.61719 16.4062 7.61719H8.64258C8.1041 7.61719 7.66602 7.1791 7.66602 6.64062V1.95312ZM19.3359 23.0469H5.71289V14.4531C5.71289 13.9146 6.15098 13.4766 6.68945 13.4766H18.3594C18.8979 13.4766 19.3359 13.9146 19.3359 14.4531V23.0469ZM23.0469 22.0703C23.0469 22.6088 22.6088 23.0469 22.0703 23.0469H21.2891V14.4531C21.2891 12.8377 19.9748 11.5234 18.3594 11.5234H6.68945C5.07402 11.5234 3.75977 12.8377 3.75977 14.4531V23.0469H2.92969C2.39121 23.0469 1.95312 22.6088 1.95312 22.0703V2.92969C1.95312 2.39121 2.39121 1.95312 2.92969 1.95312H5.71289V6.64062C5.71289 8.25605 7.02715 9.57031 8.64258 9.57031H16.4062C18.0217 9.57031 19.3359 8.25605 19.3359 6.64062V1.95312H19.7127L23.0469 5.2873V22.0703Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.f3d3333bc8f329f7e115c2044b7c134e.svg";
export { ForwardRef as ReactComponent };